<template lang="pug">
  .builds
    filterable-table
      template(v-slot="{ bus }")
        orders-list-table(
          :bus="bus"
          :constructorNames="constructorNames"
          :orderStatuses="orderStatuses"
          :orders="orders"
          ref="table"
        )
    sweet-modal(ref="msgToClientPopup")
      h2 Написать клиенту
      .popup__body Кнопоньки
</template>

<script>
import OrdersListTable from './OrdersListTable.vue';
import FilterableTable from '@/components/FilterableTable/FilterableTable.vue';

export default {
  props: {
    orders: {
      type: Array,
      required: true
    },

    constructorNames: {
      type: Array,
      required: true,
      default: () => []
    },

    orderStatuses: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    filterByStatus(status) {
      this.$refs['table'].filterByStatus(status);
    }
  },

  components: {
    FilterableTable,
    OrdersListTable
  }
};
</script>
